<template>
  <v-content class="backgroundcolordark">
    <v-layout justify-center>
  <section id="feed">
    <feed class="ma-5">
      <slot />
    </feed>
  </section>
    </v-layout>
  </v-content>
</template>

<script>
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Blog'
    },
    components: {
      Feed: () => import('@/components/Feed')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Articles.vue